export default "__VITE_ASSET__Cfd$u8A2__"